export default {
    paddingLabel: {
        paddingTop: 20, paddingLeft: 10, paddingRight: 10, paddingBottom: 3,

    } as React.CSSProperties,
    paddingField: {
        paddingTop: 20, paddingLeft: 10, paddingRight: 10
    } as React.CSSProperties,
    paddingViewable: {
        paddingLeft: 10, paddingRight: 10,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        maxWidth: 200,
    } as React.CSSProperties,

    paddingViewableWithOverflow: {
        paddingLeft: 10, paddingRight: 10,

    } as React.CSSProperties,
    text: {
        fontSize: 16,
        fontWeight: "bold",
        textTransform: "uppercase",
    } as React.CSSProperties,
    inheritText: {
        fontSize: 16,
        fontWeight: "bold",
        textTransform: "inherit",
    } as React.CSSProperties,
}